import React from "react"
import * as S from "./certificatesStyle.js"
import Alura from "../../assets/imgs/certificates/alura.png"
import Coursera from "../../assets/imgs/certificates/coursera.png"
import Footer from "../footer/footer.js"
export default function Certificates(){
    return(
        <S.Section>
            <S.H1>Certificados</S.H1>
            <S.AllCertificates>
                <S.Certificate>
                    <S.FigureImg>
                        <S.Img src={Alura} alt="" />
                    </S.FigureImg>
                    <S.Information>
                        <S.Title>JavaScript: conhecendo o Browser e padrões de projeto</S.Title>
                        <S.Company>Alura</S.Company>
                        <S.Date>Emitido em out de 2022 · Sem data de expiração</S.Date>
                        <a href="https://cursos.alura.com.br/certificate/239fd4ca-ad70-4580-a240-1bef1fef5138" rel="noreferrer"  target="_blank"><S.Btn>Exibir Certificado!</S.Btn></a>
                    </S.Information>
                </S.Certificate>
                <S.Certificate>
                    <S.FigureImg>
                        <S.Img src={Alura} alt="" />
                    </S.FigureImg>
                    <S.Information>
                        <S.Title>JavaScript: explorando a linguagem</S.Title>
                        <S.Company>Alura</S.Company>
                        <S.Date>Emitido em out de 2022 · Sem data de expiração</S.Date>
                        <a href="https://cursos.alura.com.br/certificate/b942dd12-c0bd-4f20-9501-e2543d17f675" rel="noreferrer"  target="_blank"><S.Btn>Exibir Certificado!</S.Btn></a>
                    </S.Information>
                </S.Certificate>
                <S.Certificate>
                    <S.FigureImg>
                        <S.Img src={Alura} alt="" />
                    </S.FigureImg>
                    <S.Information>
                        <S.Title>SEO: otimização de sites</S.Title>
                        <S.Company>Alura</S.Company>
                        <S.Date>Emitido em out de 2022 · Sem data de expiração</S.Date>
                        <a href="https://cursos.alura.com.br/certificate/d3188e35-92a6-457b-8d8b-84c94f3190fe" rel="noreferrer"  target="_blank"><S.Btn>Exibir Certificado!</S.Btn></a>
                    </S.Information>
                </S.Certificate>
                <S.Certificate>
                    <S.FigureImg>
                        <S.Img src={Alura} alt="" />
                    </S.FigureImg>
                    <S.Information>
                        <S.Title>Arquitetura CSS: descomplicando os problemas</S.Title>
                        <S.Company>Alura</S.Company>
                        <S.Date>Emitido em out de 2022 · Sem data de expiração</S.Date>
                        <a href="https://cursos.alura.com.br/certificate/6ffc4cb7-b6d6-4c5d-ae9e-8fd053667d12" rel="noreferrer"  target="_blank"><S.Btn>Exibir Certificado!</S.Btn></a>
                    </S.Information>
                </S.Certificate>
                <S.Certificate>
                    <S.FigureImg>
                        <S.Img src={Alura} alt="" />
                    </S.FigureImg>
                    <S.Information>
                        <S.Title>Bootstrap 4: criando uma landing page responsiva</S.Title>
                        <S.Company>Alura</S.Company>
                        <S.Date>Emitido em <set></set> de 2022 · Sem data de expiração</S.Date>
                        <a href="https://cursos.alura.com.br/certificate/e92dfc8a-754c-485e-8971-2a8fa06d0a26" rel="noreferrer"  target="_blank"><S.Btn>Exibir Certificado!</S.Btn></a>
                    </S.Information>
                </S.Certificate>
                <S.Certificate>
                    <S.FigureImg>
                        <S.Img src={Alura} alt="" />
                    </S.FigureImg>
                    <S.Information>
                        <S.Title>CSS: dispondo elementos com Flexbox e Grid</S.Title>
                        <S.Company>Alura</S.Company>
                        <S.Date>Emitido em set de 2022 · Sem data de expiração</S.Date>
                        <a href="https://cursos.alura.com.br/certificate/aa2e5e57-04fd-42a4-a200-73482bb26967" rel="noreferrer"  target="_blank"><S.Btn>Exibir Certificado!</S.Btn></a>
                    </S.Information>
                </S.Certificate>
                <S.Certificate>
                    <S.FigureImg>
                        <S.Img src={Alura} alt="" />
                    </S.FigureImg>
                    <S.Information>
                        <S.Title>Flexbox: posicione elementos na tela</S.Title>
                        <S.Company>Alura</S.Company>
                        <S.Date>Emitido em set de 2022 · Sem data de expiração</S.Date>
                        <a href="https://cursos.alura.com.br/certificate/b1aa130b-30e2-4b74-a40e-1c42800cc5f3" rel="noreferrer"  target="_blank"><S.Btn>Exibir Certificado!</S.Btn></a>
                    </S.Information>
                </S.Certificate>
                <S.Certificate>
                    <S.FigureImg>
                        <S.Img src={Alura} alt="" />
                    </S.FigureImg>
                    <S.Information>
                        <S.Title>Formação Iniciante em Programação - ONE</S.Title>
                        <S.Company>Alura</S.Company>
                        <S.Date>Emitido em set de 2022 · Sem data de expiração</S.Date>
                        <a href="https://cursos.alura.com.br/degree/certificate/0732a721-12ac-4ea2-bd65-25df940d6346" rel="noreferrer"  target="_blank"><S.Btn>Exibir Certificado!</S.Btn></a>
                    </S.Information>
                </S.Certificate>
                <S.Certificate>
                    <S.FigureImg>
                        <S.Img src={Alura} alt="" />
                    </S.FigureImg>
                    <S.Information>
                        <S.Title>Formação HTML e CSS</S.Title>
                        <S.Company>Alura</S.Company>
                        <S.Date>Emitido em out de 2022 · Sem data de expiração</S.Date>
                        <a href="https://cursos.alura.com.br/certificate/239fd4ca-ad70-4580-a240-1bef1fef5138" rel="noreferrer"  target="_blank"><S.Btn>Exibir Certificado!</S.Btn></a>
                    </S.Information>
                </S.Certificate>
                <S.Certificate>
                    <S.FigureImg>
                        <S.Img src={Alura} alt="" />
                    </S.FigureImg>
                    <S.Information>
                        <S.Title>HTML e CSS: praticando HTML/CSS</S.Title>
                        <S.Company>Alura</S.Company>
                        <S.Date>Emitido em set de 2022 · Sem data de expiração</S.Date>
                        <a href="https://cursos.alura.com.br/certificate/1df13171-f1d4-47fc-b97c-aeef4454221e" rel="noreferrer"  target="_blank"><S.Btn>Exibir Certificado!</S.Btn></a>
                    </S.Information>
                </S.Certificate>
                <S.Certificate>
                    <S.FigureImg>
                        <S.Img src={Alura} alt="" />
                    </S.FigureImg>
                    <S.Information>
                        <S.Title>HTML e CSS: responsividade com mobile-first</S.Title>
                        <S.Company>Alura</S.Company>
                        <S.Date>Emitido em set de 2022 · Sem data de expiração</S.Date>
                        <a href="https://cursos.alura.com.br/certificate/8df2df1a-30ab-46df-bd20-bf10e1fc727a" rel="noreferrer"  target="_blank"><S.Btn>Exibir Certificado!</S.Btn></a>
                    </S.Information>
                </S.Certificate>
                <S.Certificate>
                    <S.FigureImg>
                        <S.Img src={Coursera} alt="" />
                    </S.FigureImg>
                    <S.Information>
                        <S.Title>Iniciar o processo de design de UX: criar empatia, definir e idealizar (Google)</S.Title>
                        <S.Company>Coursera</S.Company>
                        <S.Date>Emitido em set de 2022 · Sem data de expiração</S.Date>
                        <a href="https://www.coursera.org/account/accomplishments/certificate/7YQLMMCW3EU2" rel="noreferrer"  target="_blank"><S.Btn>Exibir Certificado!</S.Btn></a>
                    </S.Information>
                </S.Certificate>
                <S.Certificate>
                    <S.FigureImg>
                        <S.Img src={Alura} alt="" />
                    </S.FigureImg>
                    <S.Information>
                        <S.Title>JavaScript: programando na linguagem da web</S.Title>
                        <S.Company>Alura</S.Company>
                        <S.Date>Emitido em set de 2022 · Sem data de expiração</S.Date>
                        <a href="https://cursos.alura.com.br/certificate/26103608-ae34-4058-8d7b-948bd1a2627f" rel="noreferrer"  target="_blank"><S.Btn>Exibir Certificado!</S.Btn></a>
                    </S.Information>
                </S.Certificate>
                <S.Certificate>
                    <S.FigureImg>
                        <S.Img src={Alura} alt="" />
                    </S.FigureImg>
                    <S.Information>
                        <S.Title>Javascript e HTML: desenvolva um jogo e pratique lógica de programação</S.Title>
                        <S.Company>Alura</S.Company>
                        <S.Date>Emitido em set de 2022 · Sem data de expiração</S.Date>
                        <a href="https://cursos.alura.com.br/certificate/4b6e640b-45d2-4fcf-aeaa-5392bb69902f" rel="noreferrer"  target="_blank"><S.Btn>Exibir Certificado!</S.Btn></a>
                    </S.Information>
                </S.Certificate>
                <S.Certificate>
                    <S.FigureImg>
                        <S.Img src={Alura} alt="" />
                    </S.FigureImg>
                    <S.Information>
                        <S.Title>Javascript e HTML: desenvolva um jogo e pratique lógica de programação</S.Title>
                        <S.Company>Alura</S.Company>
                        <S.Date>Emitido em set de 2022 · Sem data de expiração</S.Date>
                        <a href="https://cursos.alura.com.br/certificate/4b6e640b-45d2-4fcf-aeaa-5392bb69902f" rel="noreferrer"  target="_blank"><S.Btn>Exibir Certificado!</S.Btn></a>
                    </S.Information>
                </S.Certificate>
                <S.Certificate>
                    <S.FigureImg>
                        <S.Img src={Alura} alt="" />
                    </S.FigureImg>
                    <S.Information>
                        <S.Title>Javascript e HTML: pratique lógica com desenhos, animações e um jogo</S.Title>
                        <S.Company>Alura</S.Company>
                        <S.Date>Emitido em set de 2022 · Sem data de expiração</S.Date>
                        <a href="https://cursos.alura.com.br/certificate/4c95251d-9294-4b27-8502-dc6924b4f240" rel="noreferrer"  target="_blank"><S.Btn>Exibir Certificado!</S.Btn></a>
                    </S.Information>
                </S.Certificate>
                <S.Certificate>
                    <S.FigureImg>
                        <S.Img src={Alura} alt="" />
                    </S.FigureImg>
                    <S.Information>
                        <S.Title>Layouts Responsivos: trabalhando com layouts mobile</S.Title>
                        <S.Company>Alura</S.Company>
                        <S.Date>Emitido em set de 2022 · Sem data de expiração</S.Date>
                        <a href="https://cursos.alura.com.br/certificate/4105c6d0-41e3-4a12-9b41-dda37a2197fe" rel="noreferrer"  target="_blank"><S.Btn>Exibir Certificado!</S.Btn></a>
                    </S.Information>
                </S.Certificate>
                <S.Certificate>
                    <S.FigureImg>
                        <S.Img src={Alura} alt="" />
                    </S.FigureImg>
                    <S.Information>
                        <S.Title>Scrum: agilidade em seu projeto</S.Title>
                        <S.Company>Alura</S.Company>
                        <S.Date>Emitido em set de 2022 · Sem data de expiração</S.Date>
                        <a href="https://cursos.alura.com.br/certificate/891e7c4a-bcf9-4544-9dc9-edd15f15019c" rel="noreferrer"  target="_blank"><S.Btn>Exibir Certificado!</S.Btn></a>
                    </S.Information>
                </S.Certificate>
                <S.Certificate>
                    <S.FigureImg>
                        <S.Img src={Alura} alt="" />
                    </S.FigureImg>
                    <S.Information>
                        <S.Title>Web Design Responsivo: Páginas que se adaptam do mobile ao desk</S.Title>
                        <S.Company>Alura</S.Company>
                        <S.Date>Emitido em set de 2022 · Sem data de expiração</S.Date>
                        <a href="https://cursos.alura.com.br/certificate/71078b3c-2a02-49bc-b6c2-a8364310634c" rel="noreferrer"  target="_blank"><S.Btn>Exibir Certificado!</S.Btn></a>
                    </S.Information>
                </S.Certificate>
                <S.Certificate>
                    <S.FigureImg>
                        <S.Img src={Alura} alt="" />
                    </S.FigureImg>
                    <S.Information>
                        <S.Title>Acessibilidade web: crie designs inclusivos</S.Title>
                        <S.Company>Alura</S.Company>
                        <S.Date>Emitido em ago de 2022 · Sem data de expiração</S.Date>
                        <a href="https://cursos.alura.com.br/certificate/fda7b839-a5e0-4ccc-b7d8-be901c37d9ea" rel="noreferrer"  target="_blank"><S.Btn>Exibir Certificado!</S.Btn></a>
                    </S.Information>
                </S.Certificate>
            </S.AllCertificates>
            <Footer />
        </S.Section>
    )
}